// extracted by mini-css-extract-plugin
export default {"image_section":"lazy_image_section__-RdVF","revealed_image":"lazy_revealed_image__6Cj9m","visible":"lazy_visible__Xq85P"};